import { makeAutoObservable } from "mobx";
import { P24_CHANNEL_ID, P24_CHANNEL_TAG, isAppleChannelId } from "./P24";
const PAYMENT_CHANNELS_WITH_ADDRESS_REQUIRED = [P24_CHANNEL_ID.PAYPO];
export class Payment {
    constructor(params) {
        this.address = params.address;
        this.medium = params.medium;
        this.isRestored = params.isRestored;
        makeAutoObservable(this);
    }
    static fromStorageData(params) {
        const isStoredMediumAvailable = isMediumAvailable(params.storageData, params.restaurant.paymentMethods, params.restaurant.paymentChannels);
        return new Payment({
            address: params.paymentAddress,
            medium: isStoredMediumAvailable ? params.storageData : null,
            isRestored: isStoredMediumAvailable,
        });
    }
    get method() {
        // TODO: default payment method?
        if (!this.medium) {
            return "Cash";
        }
        return this.medium.method;
    }
    // TODO: different abstraction for channels with specific logic, like PayPo & Blik
    get isAddressRequired() {
        if (this.medium === null || this.medium.type !== "channel") {
            return false;
        }
        return (this.medium.channelId.tag === P24_CHANNEL_TAG &&
            PAYMENT_CHANNELS_WITH_ADDRESS_REQUIRED.includes(this.medium.channelId.contents));
    }
    get isApplePay() {
        var _a;
        return (((_a = this.medium) === null || _a === void 0 ? void 0 : _a.type) === "channel" && isAppleChannelId(this.medium.channelId));
    }
    get isBlikLevel0() {
        var _a;
        return (((_a = this.medium) === null || _a === void 0 ? void 0 : _a.type) === "channel" &&
            this.medium.channelId.tag === P24_CHANNEL_TAG &&
            this.medium.channelId.contents === P24_CHANNEL_ID.BLIK_LEVEL_0);
    }
    get storageData() {
        return this.medium;
    }
}
export function equalPaymentChannelIds(a, b) {
    if (a.tag !== "StripeChannel" && b.tag !== "StripeChannel") {
        return a.tag === b.tag && a.contents === b.contents;
    }
    return a.tag === "StripeChannel" && b.tag === "StripeChannel";
}
function isMediumAvailable(storageData, paymentMethods, paymentChannels) {
    if (storageData === null) {
        return false;
    }
    switch (storageData.type) {
        case "method":
            return paymentMethods.some((method) => method === storageData.method);
        case "channel":
            // NOTICE: When payment channels haven't been fetched yet (e.g., Cart page),
            // trust the stored channel if Online payment method is available.
            // The channel was validated when originally selected in Checkout and will
            // be validated again before placing an order.
            if (paymentChannels.isEmpty) {
                return paymentMethods.includes("Online");
            }
            return paymentChannels
                .filtered((channel) => channel.enabled === true)
                .some((channel) => equalPaymentChannelIds(channel.id, storageData.channelId));
    }
}
